import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { NavLink } from 'react-router-dom';
import { Dropdown } from 'semantic-ui-react';
// import { FaTwitter, FaInstagram, FaPinterest, FaYoutube } from 'react-icons/fa';
import LogRocket from 'logrocket';
import { signOut } from '../../../actions/authActions';
import * as aaUtil from '../../utils/aaUtils';

import './AthHeader.css';

let dropdownOptions = [
    { value: 'profile', text: 'Hair Profile' },
    { value: 'recommendations', text: 'Recommendations' },
    { value: 'logout', text: 'Log out' }
];

class AthHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      active: false,
      visitedRecommendations: false,
      currentPage: props.location.pathname,
      showMobileMenu: false
    };

  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll, false);
    const userId = localStorage.getItem("ath_user_id");
    // if (userId && process.env.REACT_APP_ENV === "prod") {
    //     LogRocket.identify(userId.toString(), {
    //       name: localStorage.getItem("ath_user_firstname") || "",
    //       email: localStorage.getItem("ath_email") || ""
    //     });
    // }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll, false);
  }

  event2Tracking = (event) => {
    aaUtil.event2_click_event(event);
  }

  handleScroll = () => {
    let body = document.getElementsByTagName("body")[0];
      if (window.pageYOffset >= 5) {
         body.classList.add('top', 'fixed', 'scroll', 'animation');
      } else {
         body.classList.remove('top', 'fixed', 'scroll', 'animation');
      }
  }

  selectDropdownOption = (event, data) => {
        const value = data.value;
        if (value === 'profile') {
          this.event2Tracking('Navigate to Profile (Dropdown)');
            this.props.history.push('/ath/profile');
        } else if (value === 'order-history') {
            this.props.history.push('/orders');
        } else if (value === 'logout') {
            this.props.signOut();
        } else if (value === 'recommendations') {
            this.event2Tracking('Navigate to Recommendations (Dropdown)');
            this.props.history.push('/ath/recommendations');
        }
    }

  handleShowMobileMenu = () => {
    this.setState({ showMobileMenu: !this.state.showMobileMenu }, () => {
       let body = document.getElementsByTagName("html")[0];
      if (this.state.showMobileMenu) {
        body.classList.add('mega-menu-open');
      } else {
        body.classList.remove('mega-menu-open');
      }
    });
  }

  render() {
      // if (this.props.location.pathname === '/onboarding') {
      //     const padding = '2% 0';

      //     //Formula used in older verison
      //     //window.innerHeight * 0.032 + 'px 0';
      //     return (
      //         <div className="onboarding-menu" style={{ 'padding': padding }}>
      //             <NavLink className="menu-item-center" style={{margin:'auto'}} to="/">
      //                 <ReactSVG path="/images/helloava-logo.svg" wrapperClassName="svg-wrapper" />
      //             </NavLink>
      //             <Responsive minWidth={ 901 }><StepsHeader step={1} wait={1500} /></Responsive>
      //         </div>
      //     );
      // }

    const isAuthenticated = localStorage.getItem("ath_auth_token");
    const dropdownTrigger = (<span>{ localStorage.getItem('ath_user_firstname') }</span>);

    return(
      <div className="header-home">
        <div className="wrap-home-header">
            <header data-component="mega-menu" className={ this.props.onboarding ? "header-wrapper onboarding" : "header-wrapper" }>
                <div className="header-wrapper-container">
                  <div className="header" id="header-area">
                    <div className="header-wrapper-navigation">
                      <button onClick={ this.handleShowMobileMenu } data-action="toggle-menu" className="burger" type="button" name="menu button" id="burgerMenuIcon" aria-label="Menu Button">
                          <span className="line"></span>
                      </button>
                      <nav className="navigation header-navigation-aux header-navigation-top">
                        <ul id="menu-hair-care" className="menu">
                          <li id="menu-item-76777" className="menu-item menu-item-type-taxonomy menu-item-object-category menu-item-76777"><a href="https://www.allthingshair.com/en-us/hairstyles-haircuts/">Hairstyles &#038; Haircuts</a></li>
                          <li id="menu-item-83743" className="menu-item menu-item-type-taxonomy menu-item-object-category menu-item-83743"><a href="https://www.allthingshair.com/en-us/hairstyles-haircuts/hair-tutorials/">Tutorials</a></li>
                          <li id="menu-item-170" className="menu-item menu-item-type-custom menu-item-object-custom menu-item-170"><a href="https://www.allthingshair.com/en-us/hair-care/">Hair Care</a></li>
                          <li id="menu-item-76817" className="menu-item menu-item-type-custom menu-item-object-custom menu-item-76817"><a href="https://www.allthingshair.com/en-us/hair-products/">Hair Products</a></li>
                          <li id="menu-item-77285" className="menu-item menu-item-type-custom menu-item-object-custom menu-item-77285"><a href="https://www.allthingshair.com/en-us/mens-hairstyles/">Men</a></li>
                        </ul>
                      </nav>
                  </div>
                    <div className="header-navigation-right">
                      {
                        localStorage.getItem("ath_auth_token") &&
                        <div className="ath-ha-header-links">
                        <ul>
                          <li>
                            <a style={{cursor: "pointer"}} onClick={ () => { this.event2Tracking('Navigate to Profile (Dropdown)');this.props.history.push('/ath/profile'); } }  className="ath-ha-header-links__link">
                              Hair Profile
                            </a>
                          </li>
                          <li>
                            <a style={{cursor: "pointer"}} onClick={ () => { this.event2Tracking('Navigate to Recommendations (Header)');this.props.history.push('/ath/recommendations'); } } className="ath-ha-header-links__link">
                              Recommendations
                            </a>
                          </li>
                        </ul>
                      </div>
                    }
                      <div className="ath-ha-header-right-section">
                      { isAuthenticated ?
                        <Dropdown trigger={ dropdownTrigger } options={ dropdownOptions } onChange={ this.selectDropdownOption } selectOnBlur={ false } /> :
                          null
                          }

{/*                             
                            <NavLink className="menu-item" to="/ath/login" onClick={ () => {
                              this.props.history.push('/ath/login'); 
                            }}>Sign In</NavLink>
                             */}


                            <NavLink to="/ath/onboarding" onClick={ () => {
                              this.event2Tracking('Navigate to Onboarding (Top Nav)') 
                              this.props.history.push('/ath/onboarding'); 
                            }}>
                              <button>{ isAuthenticated ? 'RETAKE QUIZ' : 'Learn More' }</button>
                            </NavLink>
                      </div>
                      

                    {/*
                      <div className="voice-assistant-menu">
                        <a href="https://www.allthingshair.com/en-us/voice-assistant/" className="text voice-assistant-menu-item">Voice Assistant</a>
                      </div>
                      <div className="social-follow">
                        <span className="text icon-arrow-left">Follow</span>
                        <nav className="navigation navigation-social-header">
                          <ul id="menu-social-links" className="menu">
                            <li id="menu-item-61228" className="icon-twitter menu-item menu-item-type-custom menu-item-object-custom menu-item-61228"><a title="Twitter &#8211; Link opens in a new window" target="_blank" rel="noopener" href="https://twitter.com/AllThingsHairus">Twitter</a></li>
                            <li id="menu-item-85732" className="icon-instagram menu-item menu-item-type-custom menu-item-object-custom menu-item-85732">
                              <a title="Instagram &#8211; Link opens in a new window" target="_blank" rel="noopener" href="https://www.instagram.com/allthingshairus/">Instagram</a>
                            </li>
                            <li id="menu-item-85736" className="icon-pinterest menu-item menu-item-type-custom menu-item-object-custom menu-item-85736">
                              <a title="Pinterest &#8211; Link opens in a new window" target="_blank" rel="noopener" href="https://www.pinterest.co.uk/AllThingsHair/?sender=312507799051457958&#038;invite_code=161cde27bc3a303cc37118cf2be4ce6e">Pinterest</a>
                            </li>
                            <li id="menu-item-85735" className="icon-youtube menu-item menu-item-type-custom menu-item-object-custom menu-item-85735">
                              <a title="YouTube &#8211; Link opens in a new window" target="_blank" rel="noopener" href="https://www.youtube.com/user/AllThingsHairUS">YouTube</a>
                            </li>
                          </ul>
                        </nav>
                      </div>
                      <button className="btn-search" type="button" name="search" data-onespot-action="click-search" data-tab="Toggle Search" aria-label="Button search">
                          <div className="btn-search-icon">
                            <div className="btn-search-open">
                              <i className="icon-search-secondary"></i>
                            </div>
                            <strong className="icon-close">
                              <strong className="line"></strong>
                            </strong>
                          </div>
                          <span className="btn-search-text">
                            { isAuthenticated ?
                              <span onClick={ this.props.signOut } className="open">Log Out</span> :
                              <span onClick={ () => this.props.history.push('/ath/login') }  className="open">Sign In</span>
                            }
                            <span className="close">close</span>
                          </span>
                      </button>
                    */}
                    </div>
                    {/* {
                        localStorage.getItem("ath_auth_token") ? 
                          <div className="ath-cart-area" onClick={ ()=>{
                              window.Cart.open_cart();
                            }}>
                            <i className="shoppable-cart-open-button" style={{height:'33px'}}></i>
                          </div> : <span></span>
                      } */}
                  </div>
                <h1 className="header-branding">
                  <a href="https://www.allthingshair.com/en-us/" title="All Things Hair United States">
                    <img className="line" src="https://www.allthingshair.com/en-us/wp-content/themes/ath-2017/assets/images/branding-compressed.svg" alt="All Things Hair United States" />
                    <span className="square">
                      <img src="https://www.allthingshair.com/en-us/wp-content/themes/ath-2017/assets/images/branding.svg" alt="All Things Hair United States" />
                      <span className="branding-text">From hair experts at Unilever</span>
                    </span>
                  </a>
                </h1>
              </div>
              <div className={ this.state.showMobileMenu ? "header-navigation show" : "header-navigation" }>
                <div className="header-navigation-mobile has-menu">
                  <nav class="nav" style={{height: "100vh"}}>
                    <ul id="menu-header-menu-aux" class="menu">
                      <li id="menu-item-263" class="menu-item menu-item-type-taxonomy menu-item-object-category menu-item-263"><a href="/ath/onboarding" data-di-id="di-id-23fd3f2c-9fe92965">{ isAuthenticated ? "Retake Quiz" : "Start the Quiz" }.</a>
                            <button type="button" data-action="nav-next" class="icon-arrow-secondary-right next-nav" name="Navigation Next" aria-label="Navigation Next"></button>
                        </li>
                        {
                          isAuthenticated ?
                           <li id="menu-item-263" class="menu-item menu-item-type-taxonomy menu-item-object-category menu-item-263"><a href="/ath/profile/" data-di-id="di-id-23fd3f2c-9fe92965">Hair Profile.</a>
                            <button type="button" data-action="nav-next" class="icon-arrow-secondary-right next-nav" name="Navigation Next" aria-label="Navigation Next"></button>
                        </li>
                          : null

                          // <li id="menu-item-263" class="menu-item menu-item-type-taxonomy menu-item-object-category menu-item-263"><a href="/ath/login/" data-di-id="di-id-23fd3f2c-9fe92965">Sign in.</a>
                          //   <button type="button" data-action="nav-next" class="icon-arrow-secondary-right next-nav" name="Navigation Next" aria-label="Navigation Next"></button>
                          // </li>

                        }
                        {
                          isAuthenticated &&
                        <li onClick={ this.trackNavToReco } id="menu-item-262" class="menu-item menu-item-type-taxonomy menu-item-object-category menu-item-262"><a href="/ath/recommendations" data-di-id="di-id-d1c2bfd0-a9d2101">Recommendations.</a>
                            <button type="button" data-action="nav-next" class="icon-arrow-secondary-right next-nav" name="Navigation Next" aria-label="Navigation Next"></button>
                        </li> }
                        <li id="menu-item-263" class="menu-item menu-item-type-taxonomy menu-item-object-category menu-item-263"><a href="https://www.allthingshair.com/en-us/hairstyles-haircuts/" data-di-id="di-id-23fd3f2c-9fe92965">Hairstyles.</a>
                            <button type="button" data-action="nav-next" class="icon-arrow-secondary-right next-nav" name="Navigation Next" aria-label="Navigation Next"></button>
                        </li>
                        <li id="menu-item-262" class="menu-item menu-item-type-taxonomy menu-item-object-category menu-item-262"><a href="https://www.allthingshair.com/en-us/hair-care/" data-di-id="di-id-d1c2bfd0-a9d2101">Hair Care.</a>
                            <button type="button" data-action="nav-next" class="icon-arrow-secondary-right next-nav" name="Navigation Next" aria-label="Navigation Next"></button>
                        </li>
                        <li id="menu-item-61230" class="menu-item menu-item-type-taxonomy menu-item-object-category menu-item-61230"><a href="https://www.allthingshair.com/en-us/hair-products/" data-di-id="di-id-32dac5e6-9b7fcbdf">Hair Products.</a>
                            <button type="button" data-action="nav-next" class="icon-arrow-secondary-right next-nav" name="Navigation Next" aria-label="Navigation Next"></button>
                        </li>
                        <li id="menu-item-264" class="menu-item menu-item-type-taxonomy menu-item-object-category menu-item-264"><a href="https://www.allthingshair.com/en-us/mens-hairstyles/" data-di-id="di-id-51103cd6-25f8921f">Men.</a>
                            <button type="button" data-action="nav-next" class="icon-arrow-secondary-right next-nav" name="Navigation Next" aria-label="Navigation Next"></button>
                        </li>
                        <li id="menu-item-85064" class="menu-item menu-item-type-taxonomy menu-item-object-category menu-item-85064"><a href="https://www.allthingshair.com/en-us/hairstyles-haircuts/hair-tutorials/" data-di-id="di-id-a3ec9cd0-a92f3e05">Tutorials.</a>
                            <button type="button" data-action="nav-next" class="icon-arrow-secondary-right next-nav" name="Navigation Next" aria-label="Navigation Next"></button>
                        </li>
                        <li class="menu-item"><a href="https://www.allthingshair.com/en-us/subscribe/" class="text" data-di-id="di-id-48d57f18-1f23ada3">Subscribe.</a>
                            <button type="button" data-action="nav-next" class="icon-arrow-secondary-right next-nav" name="Navigation Next" aria-label="Navigation Next"></button>
                        </li>
                        { isAuthenticated && <li class="menu-item"><a onClick={ this.props.signOut } class="text" data-di-id="di-id-48d57f18-1f23ada3">Log out.</a>
                            <button type="button" data-action="nav-next" class="icon-arrow-secondary-right next-nav" name="Navigation Next" aria-label="Navigation Next"></button>
                        </li> }
                    </ul>
                  </nav>
                  <nav class="navigation navigation-social-header" style={{height: "100vh"}}>
                      <ul id="menu-social-links-1" class="menu">
                          <li class="icon-twitter menu-item menu-item-type-custom menu-item-object-custom menu-item-61228">
                            <a title="Twitter – Link opens in a new window" target="_blank" rel="noopener noreferrer" href="https://twitter.com/AllThingsHairus" data-di-id="di-id-905ca844-4c46e2be">
                                {/* <FaTwitter color="#fff" size={20}/> */}
                                <i class="fa fa-twitter" aria-hidden="true" style={{fontSize:'20px'}}></i>
                            </a>
                              <button type="button" data-action="nav-next" class="icon-arrow-secondary-right next-nav" name="Navigation Next" aria-label="Navigation Next"></button>
                          </li>

                          <li class="icon-instagram menu-item menu-item-type-custom menu-item-object-custom menu-item-85732">
                            <a title="Instagram – Link opens in a new window" target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/allthingshairus/" data-di-id="di-id-b2644f1c-4caaef28">
                              {/* <FaInstagram color="#fff" size={20}/> */}
                              <i class="fa fa-instagram" aria-hidden="true" style={{fontSize:'20px'}}></i>
                            </a>
                            <button type="button" data-action="nav-next" class="icon-arrow-secondary-right next-nav" name="Navigation Next" aria-label="Navigation Next"></button>
                          </li>

                          <li class="icon-pinterest menu-item menu-item-type-custom menu-item-object-custom menu-item-85736">
                            <a title="Pinterest – Link opens in a new window" target="_blank" rel="noopener noreferrer" href="https://www.pinterest.co.uk/AllThingsHair/?sender=312507799051457958&amp;invite_code=161cde27bc3a303cc37118cf2be4ce6e" data-di-id="di-id-b2644f1c-3916dfde">
                              {/* <FaPinterest color="#fff" size={20}/> */}
                              <i class="fa fa-pinterest-square" aria-hidden="true" style={{fontSize:'20px'}}></i>
                            </a>
                            <button type="button" data-action="nav-next" class="icon-arrow-secondary-right next-nav" name="Navigation Next" aria-label="Navigation Next"></button>
                          </li>

                          <li class="icon-youtube menu-item menu-item-type-custom menu-item-object-custom menu-item-85735">
                            <a title="YouTube – Link opens in a new window" target="_blank" rel="noopener noreferrer" href="https://www.youtube.com/user/AllThingsHairUS" data-di-id="di-id-fbdf70b-5251edac">
                              {/* <FaYoutube color="#fff" size={20}/> */}
                              <i class="fa fa-youtube-play" aria-hidden="true" style={{fontSize:'20px'}}></i>
                            </a>
                              <button type="button" data-action="nav-next" class="icon-arrow-secondary-right next-nav" name="Navigation Next" aria-label="Navigation Next"></button>
                          </li>
                      </ul>
                  </nav>
                </div>
              </div>
            </header>
        </div>
      </div>
    );
    /*return (
      <div id="app-menu-wrapper" className="ath-onboarding app-menu-wrapper">
        <div className={ "app-menu " + pageStyle } >
          <div className="ath-onboarding__nav-container ath-onboarding__nav-container-left">
            <ul className="ath-onboarding__nav">
              <li className="ath-onboarding__nav-item">
                <a className="ath-onboarding__nav-item-link" href="#">Hairstyles & Haircuts</a>
              </li>
              <li className="ath-onboarding__nav-item">
                <a className="ath-onboarding__nav-item-link" href="#">Tutorials</a>
              </li>
              <li className="ath-onboarding__nav-item">
                <a className="ath-onboarding__nav-item-link" href="#">Hair Care</a>
              </li>
              <li className="ath-onboarding__nav-item">
                <a className="ath-onboarding__nav-item-link" href="#">Hair Products</a>
              </li>
              <li className="ath-onboarding__nav-item">
                <a className="ath-onboarding__nav-item-link" href="#">Men</a>
              </li>
            </ul>
          </div>
          <div className="ath-onboarding__logo-container">
            <img className="ath-onboarding__logo" src="/images/ath/onboarding/ath-logo.png" />
          </div>
          <div className="ath-onboarding__nav-container ath-onboarding__nav-container-right">
            <ul className="ath-onboarding__nav">
            </ul>
          </div>
        </div>
      </div>






    );*/
  }
}

function mapStateToProps(state) {
  const { helloava } = state;
  const { isAuthenticated } = helloava.auth;
  return { isAuthenticated };
}

function mapDispatchToProps(dispatch) {
  return {
    signOut: () => dispatch(signOut())
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AthHeader));



// WEBPACK FOOTER //
// ./src/ath/components/header/AthHeader.js